import styled from 'styled-components';
import {PrimaryLink} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import {defaultTheme, textSizes} from '@stencil/build-theme';

export const PolicyListHeading = styled.p`
  ${textSizes.MediumW3}
  margin-bottom: ${props => props.theme.spacing.base};
  color: rgba(70, 72, 77, 1);
`;

export const ListPara = styled.p(
  props => `
    font-size: ${props.theme.font.custom(16)};
    width:70%;
    `,
);
export const FeatureListUL = styled.ul(
  props => `
      display:flex;
      flex-direction: column;
      margin:1.6rem 0;
      > li{
        display:flex;
        padding:0.5rem 2.5rem;
        align-items: center;
      }
      `,
);

export const MorePolicyLink = styled(PrimaryLink)`
  ${textSizes.MediumW3}
  padding:${props => props.theme.spacing.base} ${props => props.theme.spacing.xxlarge};
`;

export const staticCheckedIconProps = {
  height: '1.5rem',
  width: '1.5rem',
  margin: '0px 1rem 0px 0px',
  fill: defaultTheme.colors.downriver.dark,
};
